import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#2B2B2B",
		children: [/* @__PURE__ */ _jsx("path", { d: "m2.174.638 21.209 21.209-2.037 2.036L.137 2.674z" }), /* @__PURE__ */ _jsx("path", { d: "M23.383 2.674 2.174 23.883.137 21.847 21.346.638z" })]
	})
});
export default SvgClose;
